export enum DIALOG_MESSAGES {
  HEADER_COLUMN_DELETE = 'Column(s)',
  SUB_HEADER_COLUMN_DELETE = 'Deleting the column will permanently erase the data',
  INFO_TEXT = 'Are you sure you want to delete the record?',
  HEADER_ROW_DELETE = 'Record',
  SUB_HEADER_ROW_TEXT_DELETE = 'Removing the text-only row will result in the permanent deletion of the associated subrows',
  SUB_HEADER_ROW_DELETE = 'Record deletion will also delete the associated schedule from the workbook',
  HEADER_SUB_TOTAL_DELETE = 'Subtotal(s)',
  SUB_HEADER_SUB_TOTAL_DELETE = 'After deletion or movement, the subtotal row will be automatically removed since there are no items for calculation',
  INFO_SUB_TOTAL_TEXT_DELETE = 'Are you sure you want to proceed?',
  BUTTON_SUB_TOTAL_CONFIRM_TEXT = 'Yes',
  BUTTON_SUB_TOTAL_CANCEL_TEXT = 'No',
  BUTTON_CONFIRM_TEXT = 'Delete',
  BUTTON_CANCEL_TEXT = 'Cancel',
  SUB_HEADER_TEXT_SCHEDULE = 'Are you sure you want to delete the selected schedule?',
  SUB_HEADER_RESET = 'Reset will update the schedule to its default state',
  ERROR_TEXT_RESET = `Note: This is an irreversible action. All the modifications will be discarded`,
  SUB_INFO_TEXT_RESET = 'Are you sure you want to proceed with reset?',
  BUTTON_RESET_CONFIRM_TEXT = 'Reset',
  COLUMN_MESSAGE_UPDATED = 'Column(s) updated successfully',
  COLUMN_MESSAGE_DELETED = 'Column(s) deleted successfully',
  ROW_MESSAGE_UPDATED = 'Row(s) updated successfully',
  ROW_MESSAGE_DELETED = 'Row(s) deleted successfully',
  ROW_MESSAGE_ADDED = 'Row(s) added successfully',
  ERROR_TEXT = `Note: This is an irreversible action`,
}
